// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2YIBB","signatureBlock":"Footer_signatureBlock__H-ev6","signature":"Footer_signature__3n_wr"};